import { Environment } from '../types/environment';

/* prettier-ignore */
export const environments: {
  local: Environment;
  development: Environment;
  production: Environment;
} = {
  local: {
    InPost: {
      SiteKey: 'eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJkVzROZW9TeXk0OHpCOHg4emdZX2t5dFNiWHY3blZ0eFVGVFpzWV9TUFA4In0.eyJleHAiOjIwNjQ2NjAxNjMsImlhdCI6MTc0OTMwMDE2MywianRpIjoiMGRhMWVjM2MtMzc1Yi00ODA2LTkxZDQtZGZjZTA4NDJkNzI1IiwiaXNzIjoiaHR0cHM6Ly9zYW5kYm94LWxvZ2luLmlucG9zdC5wbC9hdXRoL3JlYWxtcy9leHRlcm5hbCIsInN1YiI6ImY6N2ZiZjQxYmEtYTEzZC00MGQzLTk1ZjYtOThhMmIxYmFlNjdiOkEwM3lVX3JqWnhpb2pRUXdKNjNFS0duUEtXamZHcnBZVWhYN3YyMmhRY1UiLCJ0eXAiOiJCZWFyZXIiLCJhenAiOiJzaGlweCIsInNlc3Npb25fc3RhdGUiOiJmNDU2NzNjMy0yM2JlLTQxYjUtYTkzMy03Y2FiYmE2ZWRlN2QiLCJzY29wZSI6Im9wZW5pZCBhcGk6YXBpcG9pbnRzIiwic2lkIjoiZjQ1NjczYzMtMjNiZS00MWI1LWE5MzMtN2NhYmJhNmVkZTdkIiwiYWxsb3dlZF9yZWZlcnJlcnMiOiJwdXJlYmVhdXR5LnNrbGVwLnBsLHB1cmViZWF1dHkubG9jIiwidXVpZCI6IjJjYTlhYjJkLTgzODYtNDRjNC1hZTc3LTNkYjdmOWNmZWNjMCJ9.SR5I07xkQbWwbsmh9TIXSrt2LD2vRCxhO9aHaCJCLGPCeOAQFRzlb01cZUQavP3wNUZ8WeeT8xl8po99JZCw8XDzbP30AjVbQB1XNnxNQuT5p4qaou2w_gJy_3Ht_nwFvGTHFDAuyCFe8h2_49y8Y-A06PC6_nGpd04jxPdSTjjNu1SemXpulE59eyCgNcfE3UTgGJpcDquJJATNW4s6YE4ayV93t-oBs6v8mY_ABBixgBJa3Pm-yqYCcvlChNmPbP-BBy8V0_NuraFlPaAhYN9KHaWL4lcXHvMxkZGiKdnA8rJt3sqPcZoNltQAm9H02SDL6yjSkcEkUlA5iYLynA',
      Sandbox: true,
    },
    PayU: {
      PosId: '491493',
      Sandbox: true,
    },
    GoogleReCaptchaSiteKey: '6Le5EAIrAAAAAG6z28CwlnGgsPUCVgpxl0BiJGic',
    AppUrl: {
      SSO: 'https://login.purebeauty.loc',
      Admin: 'https://admin.purebeauty.loc',
      Shop: 'https://purebeauty.loc',
    },
    ApiHostUrl: {
      SSO: 'https://api.login.purebeauty.loc',
      Shop: 'https://api.shop.purebeauty.loc',
      Storage: 'https://api.storage.purebeauty.loc',
      Notifier: 'https://api.notifier.purebeauty.loc',
      Warehouse: 'https://api.warehouse.purebeauty.loc',
    },
    FacebookAppId: '3822111348107356',
    Features: {
      RedirectToShopAfterLogin: {
        Enabled: true,
      },
      ClearCartAfterCheckout: {
        Enabled: false,
      }
    },
  },
  development: {
    InPost: {
      SiteKey: 'eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJkVzROZW9TeXk0OHpCOHg4emdZX2t5dFNiWHY3blZ0eFVGVFpzWV9TUFA4In0.eyJleHAiOjIwNjQ2NjAxNjMsImlhdCI6MTc0OTMwMDE2MywianRpIjoiMGRhMWVjM2MtMzc1Yi00ODA2LTkxZDQtZGZjZTA4NDJkNzI1IiwiaXNzIjoiaHR0cHM6Ly9zYW5kYm94LWxvZ2luLmlucG9zdC5wbC9hdXRoL3JlYWxtcy9leHRlcm5hbCIsInN1YiI6ImY6N2ZiZjQxYmEtYTEzZC00MGQzLTk1ZjYtOThhMmIxYmFlNjdiOkEwM3lVX3JqWnhpb2pRUXdKNjNFS0duUEtXamZHcnBZVWhYN3YyMmhRY1UiLCJ0eXAiOiJCZWFyZXIiLCJhenAiOiJzaGlweCIsInNlc3Npb25fc3RhdGUiOiJmNDU2NzNjMy0yM2JlLTQxYjUtYTkzMy03Y2FiYmE2ZWRlN2QiLCJzY29wZSI6Im9wZW5pZCBhcGk6YXBpcG9pbnRzIiwic2lkIjoiZjQ1NjczYzMtMjNiZS00MWI1LWE5MzMtN2NhYmJhNmVkZTdkIiwiYWxsb3dlZF9yZWZlcnJlcnMiOiJwdXJlYmVhdXR5LnNrbGVwLnBsLHB1cmViZWF1dHkubG9jIiwidXVpZCI6IjJjYTlhYjJkLTgzODYtNDRjNC1hZTc3LTNkYjdmOWNmZWNjMCJ9.SR5I07xkQbWwbsmh9TIXSrt2LD2vRCxhO9aHaCJCLGPCeOAQFRzlb01cZUQavP3wNUZ8WeeT8xl8po99JZCw8XDzbP30AjVbQB1XNnxNQuT5p4qaou2w_gJy_3Ht_nwFvGTHFDAuyCFe8h2_49y8Y-A06PC6_nGpd04jxPdSTjjNu1SemXpulE59eyCgNcfE3UTgGJpcDquJJATNW4s6YE4ayV93t-oBs6v8mY_ABBixgBJa3Pm-yqYCcvlChNmPbP-BBy8V0_NuraFlPaAhYN9KHaWL4lcXHvMxkZGiKdnA8rJt3sqPcZoNltQAm9H02SDL6yjSkcEkUlA5iYLynA',
      Sandbox: true,
    },
    PayU: {
      PosId: '491493',
      Sandbox: true,
    },
    GoogleReCaptchaSiteKey: '6Le5EAIrAAAAAG6z28CwlnGgsPUCVgpxl0BiJGic',
    AppUrl: {
      SSO: 'https://login.purebeauty.sklep.pl',
      Admin: 'https://admin.purebeauty.sklep.pl',
      Shop: 'https://purebeauty.sklep.pl',
    },
    ApiHostUrl: {
      SSO: 'https://api.login.purebeauty.sklep.pl',
      Shop: 'https://api.shop.purebeauty.sklep.pl',
      Storage: 'https://api.storage.purebeauty.sklep.pl',
      Notifier: 'https://api.notifier.purebeauty.sklep.pl',
      Warehouse: 'https://api.warehouse.purebeauty.sklep.pl',
    },
    FacebookAppId: '3822111348107356',
    Features: {
      RedirectToShopAfterLogin: {
        Enabled: true,
      },
      ClearCartAfterCheckout: {
        Enabled: true,
      }
    },
  },
  production: {
    InPost: {
      SiteKey: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9.eyJpc3MiOiJhcGktc2hpcHgtcGwuZWFzeXBhY2syNC5uZXQiLCJzdWIiOiJhcGktc2hpcHgtcGwuZWFzeXBhY2syNC5uZXQiLCJleHAiOjE2MDU2OTAzMjUsImlhdCI6MTYwNTY5MDMyNSwianRpIjoiNTc2NGQ1NDEtNDY5MS00ODhjLWJlMjUtMTU0ZmQwZDZlOThiIn0.QeHqpSLzLzkTKOVBPb-M0Xg7Ec1t-17x6uuoIxxygCYJ788_Ph50OnE91u8GIlNCF2GT1SVvDLJShhP9n-y8Yw',
      Sandbox: false,
    },
    PayU: {
      PosId: '3616557',
      Sandbox: false,
    },
    GoogleReCaptchaSiteKey: '6LeTCGkrAAAAAFWASmI8R3IFRvvedNlIFARXjdlv',
    AppUrl: {
      SSO: 'https://login.purebeauty.pl',
      Admin: 'https://admin.purebeauty.pl',
      Shop: 'https://purebeauty.pl',
    },
    ApiHostUrl: {
      SSO: 'https://api.login.purebeauty.pl',
      Shop: 'https://api.shop.purebeauty.pl',
      Storage: 'https://api.storage.purebeauty.pl',
      Notifier: 'https://api.notifier.purebeauty.pl',
      Warehouse: 'https://api.warehouse.purebeauty.pl',
    },
    FacebookAppId: '3822111348107356',
    Features: {
      RedirectToShopAfterLogin: {
        Enabled: true,
      },
      ClearCartAfterCheckout: {
        Enabled: true,
      }
    },
  },
};
